<div class="row" *ngIf="showHeader">
  <div class="col-sm-1"></div>
  <div class="col-sm-10">
    <h1 style="font-family: Roboto, Helvetica Neue, sans-serif; font-size: 40px; font-weight: bold; color: black; margin-left: -15px;">Interactives</h1>
  </div>
  <div class="col-sm-1"></div>
</div>
<div class="row">
  <div class="col-sm-1"></div>
  <div class="col-sm-3 mainLabel">My Interactives</div>
  <div class="col-sm-2 mainLabel">Report Filter</div>
  <div class="col-sm-2 mainLabel">Report Bookmark</div>
  <div class="col-sm-2 mainLabel">
    <ng-container *ngIf="!userState.reportOnly"> Actions </ng-container>
    <ng-container *ngIf="userState.reportOnly"> Reports </ng-container>
  </div>
  <div class="col-sm-1 mainLabel"></div>
  <div class="col-sm-1"></div>
</div>
<div class="row" *ngIf="!userState.reportOnly">
  <div style="padding-left: 0px; padding-right: 0px;" class="col-sm-1"></div>
  <div style="padding-left: 0px; padding-right: 0px;" class="col-sm-3">
    <mat-form-field style="width: 100%">
      <mat-select
        [(ngModel)]="selectedInteractive"
        id="listMyInteractives"
        name="listMyInteractives"
        class="modifiedDropDown"
        (selectionChange)="selectInteractive()"
      >
        <mat-option value="-1">{{initialInteractiveName}}</mat-option>
        <ng-container *ngFor="let interactive of availableInteractives">
          <mat-option value="I-{{ interactive.interactId }}">{{
            interactive.interactName
            }}</mat-option>
        </ng-container>
        <ng-container
          *ngFor="let interactive of availableModifiedInteractives"
        >
          <mat-option value="M-{{ interactive.modInteractId }}">{{
            interactive.name
            }}</mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>
  </div>
  <div style="padding-left: 0px; padding-right: 0px;" class="col-sm-2">
    <mat-form-field style="width: 100%">
      <mat-select
        id="listMyInteractiveFilters"
        class="modifiedDropDown"
        [(ngModel)]="selectedFilter"
      >
        <mat-option value="-1">-- NO FILTER --</mat-option>
        <ng-container *ngFor="let filter of availableFilters">
          <mat-option value="{{ filter.filterId }}">{{
            filter.name
            }}</mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>
  </div>
  <div style="padding-left: 0px; padding-right: 0px;" class="col-sm-2">
    <mat-form-field style="width: 100%">
      <mat-select
        id="listMyInteractiveBookmarks"
        class="modifiedDropDown"
        [(ngModel)]="selectedBookmark"
      >
        <mat-option value="-1">-- NO BOOKMARK --</mat-option>
        <ng-container *ngFor="let bookmark of availableBookmarks">
          <mat-option value="{{ bookmark.bookmarkId }}">{{
            bookmark.name
            }}</mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>
  </div>
  <div style="padding-left: 0px; padding-right: 0px;" class="col-sm-2">
    <mat-form-field>
      <mat-select
        id="listMyInteractiveActions"
        [(ngModel)]="selectedAction"
      >
        <mat-option value="-1">-- NO ACTION --</mat-option>
        <ng-container *ngFor="let action of availableActions">
          <mat-option value="{{ action.action }}">{{
            action.display
            }}</mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>
  </div>
  <div style="padding-left: 0px; padding-right: 0px;" class="col-sm-1">
    <button
      mat-raised-button
      class="piButton"
      style="margin-top: 10px; margin-left: 8px"
      (click)="goClick()"
    >
      GO
    </button>
  </div>
  <div style="padding-left: 0px; padding-right: 0px;" class="col-sm-1"></div>
</div>
<div class="row" *ngIf="userState.reportOnly">
  <div style="padding-left: 0px; padding-right: 0px;" class="col-sm-1"></div>
  <div style="padding-left: 0px; padding-right: 0px;" class="col-sm-3">
    <mat-form-field style="width: 100%">
      <mat-select
        [(ngModel)]="selectedInteractive"
        id="listMyInteractives"
        name="listMyInteractives"
        class="modifiedDropDown"
        (selectionChange)="selectInteractive()"
      >
        <mat-option value="-1">-- NO INTERACTIVE --</mat-option>
        <ng-container *ngFor="let interactive of userState.interactives">
          <ng-container *ngIf="interactive.availableReports.length > 0">
            <mat-option value="I-{{ interactive.interactId }}">{{
              interactive.interactName
              }}</mat-option>
          </ng-container>
        </ng-container>
      </mat-select>
    </mat-form-field>
  </div>
  <div style="padding-left: 0px; padding-right: 0px;" class="col-sm-2">
    <mat-form-field style="width: 100%">
      <mat-select
        id="listMyInteractiveFilters"
        class="modifiedDropDown"
        [(ngModel)]="selectedFilter"
      >
        <mat-option value="-1">-- NO FILTER --</mat-option>
        <ng-container *ngFor="let filter of availableFilters">
          <mat-option value="{{ filter.filterId }}">{{
            filter.name
            }}</mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>
  </div>
  <div style="padding-left: 0px; padding-right: 0px;" class="col-sm-2">
    <mat-form-field style="width: 100%">
      <mat-select
        id="listMyInteractiveBookmarks"
        class="modifiedDropDown"
        [(ngModel)]="selectedBookmark"
      >
        <mat-option value="-1">-- NO BOOKMARK --</mat-option>
        <ng-container *ngFor="let bookmark of availableBookmarks">
          <mat-option value="{{ bookmark.bookmarkId }}">{{
            bookmark.name
            }}</mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>
  </div>
  <div style="padding-left: 0px; padding-right: 0px;" class="col-sm-2">
    <mat-form-field>
      <mat-select
        id="listMyInteractiveReports"
        [(ngModel)]="selectedReport"
      >
        <mat-option value="-1">-- NO REPORT --</mat-option>
        <ng-container *ngFor="let report of availableReports">
          <mat-option value="{{ report.interactReportId }}">{{
            report.name
            }}</mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>
  </div>
  <div style="padding-left: 0px; padding-right: 0px;" class="col-sm-1">
    <button
      mat-raised-button
      class="piButton"
      style="margin-top: 10px; margin-left: 8px"
      (click)="goClick()"
    >
      GO
    </button>
  </div>
  <div style="padding-left: 0px; padding-right: 0px;" class="col-sm-1"></div>
</div>
